/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ImgContainer from "@/components/Common/Utils/ImgContainer.vue";
export default {
  install: (Vue) => {
    Vue.component("ImgContainer", ImgContainer); // 自定义组件我习惯大驼峰
  },
};
